import React from "react";
import styles from "./DashboardHeader.module.css";

const DashboardHeader = () => {
  return (
    <div className={styles.header}>
  

      {/* Multi-color title */}
      <h1 className={styles.title}>
        <span>Executive Dashboard</span>{" "}
        
      </h1>

    
    </div>
  );
};

export default DashboardHeader;
